// extracted by mini-css-extract-plugin
export default {"terminal-display":"TerminalDisplay__terminal-display___QsAq5","scroll-target":"TerminalDisplay__scroll-target___19zXE"};